/* まんが記事(article.gp-manga)専用ランタイム。
 *
 * html-learning-site の assets/html-article.js を機械的に横展開したもの
 * (2026-08-11)。置換したのは次の4か所だけ:
 *   VIEW = "html-article-stream" → "gp-manga-stream"
 *   X-Requested-With: html-article → gp-manga
 *   window.HtmlArticle → window.GpManga
 *   クラス接頭辞 html-article → gp-manga-article
 * data-hta-* と .hts(サイドバー)は**変えない**(要件定義 §2)。
 *
 * Try it は残してあるが、セレクタが pre.code-block[data-tryit] なので
 * まんが記事(素の <pre><code>)では**発火しない**。消さないのは、
 * 呼び出しが無限スクロールの位置補正の順序に組み込まれており
 * (実測117pxずれの原因だった箇所)、そこを触らないため。
 *
 * 含むもの:
 *   1. Try it(このコードを実行 / 自分で書いて試す)
 *   2. 固定順の無限スクロール(前方=自動 / 後方=ボタン)
 *   3. サイドバーの現在地同期
 *
 * 依存なし。テーマの既存 JS(infinite-article.js 等)とは無関係に動く。
 * このファイルは snippets/gp-manga-article-assets.liquid からのみ読み込む。
 */
(function () {
  "use strict";

  /* handle / 章キー / トラック ID はすべて [a-z0-9-] に正規化済み。
     属性セレクタへ入れる前に必ずこれで検証し、セレクタ注入を防ぐ。 */
  var SAFE_KEY = /^[a-z0-9][a-z0-9-]*$/;

  /* ══════════════════════════════════════════════════════════
     1. Try it
     ══════════════════════════════════════════════════════════ */

  var TRYIT_SELECTOR = "pre.code-block[data-tryit]";
  var TRYIT_SOURCE = "html-tutor-tryit-v1";
  var TRYIT_PREFIX = "html-tutor-tryit:v1:";
  var tryitSeq = 0;

  function hashText(value) {
    var hash = 2166136261;
    for (var i = 0; i < value.length; i += 1) {
      hash ^= value.charCodeAt(i);
      hash = Math.imul(hash, 16777619);
    }
    return (hash >>> 0).toString(36);
  }

  function storageKey(pre, initialCode) {
    var explicit = pre.getAttribute("data-tryit-key");
    if (explicit) return TRYIT_PREFIX + explicit;
    /* data-tryit-key は export_shopify が handle 込みで付ける。無い場合だけ
       所属記事から導く。無限スクロールで複数記事が同一 DOM に載るため、
       document 全体ではなく **その pre を含む記事** を見る。 */
    var entry = pre.closest("[data-hta-entry]");
    var articleKey = entry && entry.getAttribute("data-handle");
    return TRYIT_PREFIX + (articleKey || "article") + ":" + hashText(initialCode);
  }

  function sandboxFor(code) {
    var values = ["allow-scripts"];
    if (/\b(alert|confirm|prompt)\s*\(/.test(code)) values.push("allow-modals");
    if (/target\s*=\s*["']_blank["']|window\.open\s*\(/i.test(code)) values.push("allow-popups");
    /* 学習者のコードへストアのオリジンを渡す sandbox 値は決して足さない。
       渡すと iframe 内のコードが同一オリジンとして動き、localStorage や
       Cookie に到達する。テストがこのファイル全体を文字列検査するため、
       禁止値そのものをコメントにも書かない。 */
    return values.join(" ");
  }

  function cspMeta() {
    return '<meta http-equiv="Content-Security-Policy" content="' + [
      "default-src 'none'",
      "base-uri 'none'",
      "object-src 'none'",
      "frame-src 'none'",
      "form-action 'none'",
      "connect-src 'none'",
      "img-src data: blob: https:",
      "media-src data: blob: https:",
      "font-src data:",
      "style-src 'unsafe-inline' https:",
      "script-src 'unsafe-inline'"
    ].join("; ") + '">';
  }

  function monitorScript(token) {
    var safeToken = JSON.stringify(token).replace(/</g, "\\u003c");
    return "<script>(function(){" +
      "var token=" + safeToken + ";" +
      "function send(kind,value){parent.postMessage({source:'" + TRYIT_SOURCE +
      "',token:token,kind:kind,value:String(value||'')},'*')}" +
      "addEventListener('error',function(e){send('error',e.message||'実行エラー')});" +
      "addEventListener('unhandledrejection',function(e){" +
      "send('error',e.reason&&e.reason.message||e.reason||'Promiseエラー')});" +
      "addEventListener('DOMContentLoaded',function(){send('ready','')});" +
      "})();<" + "/script>";
  }

  function securedSource(code, token) {
    var additions = cspMeta() + monitorScript(token);
    if (/<head(?:\s[^>]*)?>/i.test(code)) {
      return code.replace(/<head(?:\s[^>]*)?>/i, function (head) { return head + additions; });
    }
    var doctype = code.match(/^\s*<!doctype[^>]*>/i);
    if (doctype) return code.replace(doctype[0], doctype[0] + "<head>" + additions + "</head>");
    return "<head>" + additions + "</head>" + code;
  }

  function status(ui, message, isError) {
    ui.status.textContent = message || "";
    ui.status.classList.toggle("is-error", Boolean(isError));
    ui.status.setAttribute("role", isError ? "alert" : "status");
  }

  function makeFrame(id, title, className) {
    var frame = document.createElement("iframe");
    frame.id = id;
    frame.className = "html-tutor-tryit__frame " + className;
    frame.setAttribute("title", title);
    frame.setAttribute("referrerpolicy", "no-referrer");
    frame.setAttribute("loading", "lazy");
    frame.setAttribute("tabindex", "0");
    return frame;
  }

  function render(ui, frame, code) {
    var token = ui.id + "-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2);
    frame.setAttribute("sandbox", sandboxFor(code));
    frame.setAttribute("data-tryit-token", token);
    frame.removeAttribute("data-tryit-error");
    try {
      frame.srcdoc = securedSource(code, token);
      status(ui, "プレビューを更新しています", false);
    } catch (error) {
      status(ui, "プレビューを更新できません: " + (error.message || error), true);
    }
  }

  function setExpanded(button, expanded, label) {
    button.setAttribute("aria-expanded", expanded ? "true" : "false");
    button.textContent = label;
  }

  function closeReadonly(ui) {
    if (ui.readonlyFrame) ui.readonlyFrame.remove();
    ui.readonlyFrame = null;
    setExpanded(ui.runButton, false, "▶ このコードを実行(Try it)");
  }

  function closeEditor(ui) {
    if (ui.playground) ui.playground.remove();
    ui.playground = null;
    setExpanded(ui.editButton, false, "✎ 自分で書いて試す");
  }

  function readSaved(ui) {
    try {
      return window.localStorage.getItem(ui.storageKey);
    } catch (error) {
      status(ui, "保存済みコードを読み込めません: " + (error.message || error), true);
      return null;
    }
  }

  function save(ui, code) {
    try {
      window.localStorage.setItem(ui.storageKey, code);
    } catch (error) {
      status(ui, "編集内容を保存できません: " + (error.message || error), true);
    }
  }

  function clearSaved(ui) {
    try {
      window.localStorage.removeItem(ui.storageKey);
    } catch (error) {
      status(ui, "保存内容を削除できません: " + (error.message || error), true);
    }
  }

  function openReadonly(ui) {
    if (ui.readonlyFrame) {
      closeReadonly(ui);
      status(ui, "プレビューを閉じました", false);
      return;
    }
    closeEditor(ui);
    var frame = makeFrame(ui.id + "-run", "コードの実行プレビュー", "html-tutor-tryit__readonly");
    ui.readonlyFrame = frame;
    ui.bar.insertBefore(frame, ui.status);
    ui.runButton.setAttribute("aria-controls", frame.id);
    setExpanded(ui.runButton, true, "× プレビューを閉じる");
    render(ui, frame, ui.initialCode);
  }

  function openEditor(ui) {
    if (ui.playground) {
      closeEditor(ui);
      status(ui, "エディタを閉じました", false);
      return;
    }
    closeReadonly(ui);
    var playground = document.createElement("div");
    playground.id = ui.id + "-editor";
    playground.className = "html-tutor-tryit__playground";

    var tools = document.createElement("div");
    tools.className = "html-tutor-tryit__tools";
    var reset = document.createElement("button");
    reset.type = "button";
    reset.className = "html-tutor-tryit__reset";
    reset.textContent = "リセット";
    reset.setAttribute("aria-label", "編集内容を最初のコードに戻す");
    tools.appendChild(reset);

    /* CodeMirror 等へ差し替えられるよう、素の textarea のままにしておく。 */
    var editor = document.createElement("textarea");
    editor.className = "html-tutor-tryit__editor";
    editor.setAttribute("aria-label", "編集するHTMLコード");
    editor.setAttribute("aria-describedby", ui.status.id);
    editor.setAttribute("autocomplete", "off");
    editor.setAttribute("autocapitalize", "off");
    editor.setAttribute("spellcheck", "false");
    editor.setAttribute("wrap", "off");
    editor.spellcheck = false;
    var saved = readSaved(ui);
    editor.value = saved === null ? ui.initialCode : saved;

    var frame = makeFrame(ui.id + "-live", "編集中のコードのライブプレビュー", "html-tutor-tryit__live");
    playground.appendChild(tools);
    playground.appendChild(editor);
    playground.appendChild(frame);
    ui.bar.insertBefore(playground, ui.status);
    ui.playground = playground;
    ui.editButton.setAttribute("aria-controls", playground.id);
    setExpanded(ui.editButton, true, "× エディタを閉じる");
    render(ui, frame, editor.value);

    var timer = 0;
    editor.addEventListener("input", function () {
      save(ui, editor.value);
      window.clearTimeout(timer);
      timer = window.setTimeout(function () { render(ui, frame, editor.value); }, 250);
    });
    editor.addEventListener("keydown", function (event) {
      if (event.key !== "Tab" || event.altKey || event.ctrlKey || event.metaKey) return;
      event.preventDefault();
      var start = editor.selectionStart;
      var end = editor.selectionEnd;
      editor.setRangeText("  ", start, end, "end");
      editor.dispatchEvent(new Event("input", { bubbles: true }));
    });
    reset.addEventListener("click", function () {
      window.clearTimeout(timer);
      editor.value = ui.initialCode;
      clearSaved(ui);
      render(ui, frame, ui.initialCode);
      editor.focus();
      status(ui, "最初のコードに戻しました", false);
    });
    editor.focus();
  }

  function initTryItBlock(pre) {
    if (pre.getAttribute("data-tryit-initialized") === "v1") return;
    var code = pre.querySelector("code");
    if (!code) return;
    pre.setAttribute("data-tryit-initialized", "v1");
    tryitSeq += 1;
    var id = "html-tutor-tryit-" + tryitSeq;

    var bar = document.createElement("div");
    bar.className = "html-tutor-tryit";
    bar.setAttribute("role", "group");
    bar.setAttribute("aria-label", "HTMLコードを試す");

    var runButton = document.createElement("button");
    runButton.type = "button";
    runButton.className = "html-tutor-tryit__run";
    runButton.setAttribute("aria-expanded", "false");
    runButton.textContent = "▶ このコードを実行(Try it)";

    var editButton = document.createElement("button");
    editButton.type = "button";
    editButton.className = "html-tutor-tryit__edit";
    editButton.setAttribute("aria-expanded", "false");
    editButton.textContent = "✎ 自分で書いて試す";

    var liveStatus = document.createElement("p");
    liveStatus.id = id + "-status";
    liveStatus.className = "html-tutor-tryit__status";
    liveStatus.setAttribute("role", "status");
    liveStatus.setAttribute("aria-live", "polite");
    liveStatus.setAttribute("aria-atomic", "true");

    bar.appendChild(runButton);
    bar.appendChild(editButton);
    bar.appendChild(liveStatus);
    pre.insertAdjacentElement("afterend", bar);

    var ui = {
      id: id,
      bar: bar,
      runButton: runButton,
      editButton: editButton,
      status: liveStatus,
      initialCode: code.textContent,
      storageKey: storageKey(pre, code.textContent),
      readonlyFrame: null,
      playground: null
    };
    runButton.addEventListener("click", function () { openReadonly(ui); });
    editButton.addEventListener("click", function () { openEditor(ui); });
  }

  function initTryIt(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches(TRYIT_SELECTOR)) initTryItBlock(scope);
    Array.prototype.forEach.call(scope.querySelectorAll(TRYIT_SELECTOR), initTryItBlock);
  }

  /* ══════════════════════════════════════════════════════════
     1-b. プロンプト例のコピーボタン(2026-08-13 ユーザー指示)
     ──────────────────────────────────────────────────────────
     記事本文には <div class="gpm-prompt" data-gpm-copy> だけが入っている。
     ボタンは**ここで挿す**(本文HTMLに script を書かない方針を守る)。
     ★無限スクロールで後から追記された記事にも効かせる必要があるので、
       initTryIt と同じところから呼ぶ(root スコープで二重挿入しない)。
     ★navigator.clipboard は https と localhost でしか使えない。
       使えない環境では textarea + execCommand へ落とす(古い端末の保険)。
     ══════════════════════════════════════════════════════════ */

  var COPY_SELECTOR = ".ta-inline-copy-code";

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var area = document.createElement("textarea");
      area.value = text;
      area.setAttribute("readonly", "readonly");
      area.style.position = "fixed";
      area.style.top = "-1000px";
      document.body.appendChild(area);
      area.select();
      var ok = false;
      try { ok = document.execCommand("copy"); } catch (err) { ok = false; }
      document.body.removeChild(area);
      if (ok) resolve(); else reject(new Error("copy failed"));
    });
  }

  function initCopyBlock(box) {
    if (box.getAttribute("data-gpm-copy-ready") === "true") return;
    var button = box.querySelector(".ta-code-copy");
    var status = box.querySelector(".ta-code-copy-status");
    /* コピー元は textarea(原文そのもの)。無ければ <pre><code> から拾う。 */
    var source = box.querySelector(".ta-code-copy-source");
    var code = box.querySelector("pre code");
    if (!button || !(source || code)) return;
    box.setAttribute("data-gpm-copy-ready", "true");

    var timer = null;
    function say(message) {
      if (status) status.textContent = message;
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () { if (status) status.textContent = ""; }, 2400);
    }
    button.addEventListener("click", function () {
      var text = source ? source.value : code.textContent;
      copyText(text).then(function () {
        say("コピーしました");
      }, function () {
        /* 失敗しても「できた」と嘘をつかない。手で選んでもらう。 */
        say("コピーできませんでした");
      });
    });
  }

  function initCopy(root2) {
    var scope = root2 && root2.querySelectorAll ? root2 : document;
    if (scope.matches && scope.matches(COPY_SELECTOR)) initCopyBlock(scope);
    Array.prototype.forEach.call(scope.querySelectorAll(COPY_SELECTOR), initCopyBlock);
  }

  /* ══════════════════════════════════════════════════════════
     1-c. スマホの目次を上の追従バーから引き出す(2026-08-13 ユーザー指示)
     ──────────────────────────────────────────────────────────
     開閉の状態は **記事のルートに付ける data-gpm-side-open** だけが持つ。
     見た目は CSS(900px 以下の @media)側。ここでは属性の付け外しと、
     キーボード・オーバーレイでの閉じ方だけを面倒みる。
     ★このバーは gp-manga-toc.js が見出しを見つけるまで hidden なので、
       JS が動かない環境ではボタン自体が現れない = 従来の下の目次が残る。
     ══════════════════════════════════════════════════════════ */

  function initSideDrawer() {
    var article = document.querySelector("[data-gp-manga-article]");
    if (!article) return;
    var toggle = article.querySelector("[data-gpm-side-toggle]");
    var overlay = article.querySelector("[data-gpm-side-overlay]");
    var side = article.querySelector(".gp-manga-article__side");
    if (!toggle || !side) return;

    function setOpen(open) {
      if (open) article.setAttribute("data-gpm-side-open", "true");
      else article.removeAttribute("data-gpm-side-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      if (overlay) overlay.hidden = !open;
      /* 開いている間は後ろの本文を動かさない(引き出しの中だけスクロールする) */
      document.documentElement.style.overflow = open ? "hidden" : "";
    }

    toggle.addEventListener("click", function () {
      setOpen(!article.hasAttribute("data-gpm-side-open"));
    });
    if (overlay) overlay.addEventListener("click", function () { setOpen(false); toggle.focus(); });
    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      if (!article.hasAttribute("data-gpm-side-open")) return;
      setOpen(false);
      toggle.focus();
    });
    /* 目次のリンクを押したら閉じる(押した先へ移動するので開いたままにしない) */
    side.addEventListener("click", function (event) {
      if (event.target.closest("a")) setOpen(false);
    });
    /* PC 幅へ戻したときに引き出しの状態を持ち越さない */
    if (window.matchMedia) {
      var wide = window.matchMedia("(min-width: 901px)");
      var onWide = function (mq) { if (mq.matches) setOpen(false); };
      if (wide.addEventListener) wide.addEventListener("change", onWide);
      else if (wide.addListener) wide.addListener(onWide);
    }
  }

  window.addEventListener("message", function (event) {
    var data = event.data;
    if (!data || data.source !== TRYIT_SOURCE || !data.token) return;
    var frames = document.querySelectorAll("iframe[data-tryit-token]");
    for (var i = 0; i < frames.length; i += 1) {
      var frame = frames[i];
      if (frame.getAttribute("data-tryit-token") !== data.token) continue;
      if (event.source !== frame.contentWindow) continue;
      var bar = frame.closest(".html-tutor-tryit");
      var target = bar && bar.querySelector(".html-tutor-tryit__status");
      if (!target) return;
      /* 一度エラーになった frame は、後続の ready で緑に戻さない。 */
      if (data.kind !== "error" && frame.getAttribute("data-tryit-error") === "true") return;
      if (data.kind === "error") frame.setAttribute("data-tryit-error", "true");
      target.textContent = data.kind === "error" ? "実行エラー: " + data.value : "プレビューを更新しました";
      target.classList.toggle("is-error", data.kind === "error");
      target.setAttribute("role", data.kind === "error" ? "alert" : "status");
      return;
    }
  });

  /* ══════════════════════════════════════════════════════════
     2. 無限スクロール(固定順)
     ══════════════════════════════════════════════════════════ */

  var VIEW = "gp-manga-stream";
  var STREAM_OK = "[data-hta-stream-ok]";
  var ENTRY_SEL = "[data-hta-entry]";
  var MAX_ENTRIES = 30;      /* DOM に載せる記事数の上限(iframe とメモリの保険) */
  var FETCH_TIMEOUT = 12000;
  var PRELOAD_PX = 1200;

  var root = document.querySelector("[data-gp-manga-article]");

  function entries() {
    return root ? Array.prototype.slice.call(root.querySelectorAll(ENTRY_SEL)) : [];
  }

  function say(message) {
    var node = root && root.querySelector("[data-hta-status]");
    if (!node) return;
    node.textContent = message || "";
    node.hidden = !message;
  }

  function streamUrl(handle) {
    var url = new URL("/blogs/" + root.dataset.blog + "/" + handle, location.origin);
    url.searchParams.set("view", VIEW);
    return url.href;
  }

  /* 取得した記事断片を DOM へ入れる前に整える。
     - 上へ挿す記事の画像は eager にする。lazy のままだと挿入後に読み込みが
       走って高さが変わり、スクロール補正がずれる(=画面が飛ぶ)。 */
  function prepareNode(node, eager) {
    if (!eager) return node;
    Array.prototype.forEach.call(node.querySelectorAll("img[loading]"), function (img) {
      img.setAttribute("loading", "eager");
    });
    return node;
  }

  function fetchEntry(handle) {
    if (!SAFE_KEY.test(handle)) return Promise.reject(new Error("不正な handle"));
    var controller = new AbortController();
    var timer = window.setTimeout(function () { controller.abort(); }, FETCH_TIMEOUT);
    return fetch(streamUrl(handle), {
      credentials: "same-origin",
      headers: { "X-Requested-With": "gp-manga" },
      signal: controller.signal
    }).then(function (response) {
      if (!response.ok) throw new Error("HTTP " + response.status);
      return response.text();
    }).then(function (text) {
      var doc = new DOMParser().parseFromString(text, "text/html");
      /* ?view= は存在しない値でも 200 で別テンプレートを返す。
         判別子が無い応答は「別物」として捨てる(フルページ挿入の事故防止)。 */
      if (!doc.querySelector(STREAM_OK)) throw new Error("stream 応答ではありません");
      var entry = doc.querySelector(ENTRY_SEL);
      if (!entry) throw new Error("記事断片がありません");
      if (entry.getAttribute("data-handle") !== handle) throw new Error("handle 不一致");
      return document.importNode(entry, true);
    }).finally(function () {
      window.clearTimeout(timer);
    });
  }

  /* ── サイドバー同期 ── */

  function sidebarNav() {
    return document.querySelector("[data-hts]");
  }

  function syncSidebar(entry) {
    var nav = sidebarNav();
    if (!nav) return;
    var handle = entry.getAttribute("data-handle") || "";
    var chapter = entry.getAttribute("data-chapter") || "";
    var track = entry.getAttribute("data-track") || "";

    Array.prototype.forEach.call(nav.querySelectorAll('a[aria-current="page"]'), function (a) {
      a.removeAttribute("aria-current");
    });
    Array.prototype.forEach.call(nav.querySelectorAll(".hts__chapter--current"), function (li) {
      li.classList.remove("hts__chapter--current");
    });

    if (SAFE_KEY.test(handle)) {
      var link = nav.querySelector('.hts__page[data-handle="' + handle + '"] > a');
      if (link) link.setAttribute("aria-current", "page");
    }
    if (SAFE_KEY.test(chapter)) {
      var li = nav.querySelector('.hts__chapter[data-chapter="' + chapter + '"]');
      if (li) li.classList.add("hts__chapter--current");
    }
    Array.prototype.forEach.call(nav.querySelectorAll(".hts__track"), function (details) {
      var isCurrent = details.getAttribute("data-track") === track;
      details.classList.toggle("hts__track--current", isCurrent);
      if (isCurrent) details.open = true;
    });
  }

  /* トラックを跨いだときだけサイドバーを差し替える。
     サイドバーは「全トラックの章 + 現在トラックの全ページ」なので、
     同一トラック内の移動では取得が要らない(17回しか起きない処理)。 */
  var sidebarPending = false;
  function ensureSidebarTrack(entry) {
    var holder = document.querySelector("[data-hts-track]");
    var track = entry.getAttribute("data-track") || "";
    if (!holder || sidebarPending) return;
    if (holder.getAttribute("data-hts-track") === track) return;
    var handle = entry.getAttribute("data-handle") || "";
    if (!SAFE_KEY.test(handle)) return;
    sidebarPending = true;
    fetch("/blogs/" + root.dataset.blog + "/" + handle, { credentials: "same-origin" })
      .then(function (response) { return response.ok ? response.text() : Promise.reject(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, "text/html");
        var fresh = doc.querySelector("[data-hts]");
        var freshHolder = doc.querySelector("[data-hts-track]");
        var current = sidebarNav();
        if (!fresh || !current) return;
        current.replaceWith(document.importNode(fresh, true));
        holder.setAttribute(
          "data-hts-track",
          (freshHolder && freshHolder.getAttribute("data-hts-track")) || track
        );
        syncSidebar(entry);
      })
      .catch(function () { /* 差し替えに失敗しても章単位の強調は効いている */ })
      .finally(function () { sidebarPending = false; });
  }

  /* ── 現在地(primary)の確定 ── */

  var currentHandle = null;

  /* 表示URLに付ける `?n=<入口から何本目>&e=<入口記事ハンドル>`(2026-08-13 追加)。

     ★何のためか: GA4 の標準レポートで「無限スクロール由来のPV」を分けるため。
       **サーバーは一切読まない**。付けても付けなくてもページの中身は同じ。
     ★入口記事そのもの(n=0)には付けない。クリーンURLのまま。
     ★canonical はこのクエリを持たない。Shopify の `canonical_url` が未知クエリを
       落とすため、`?n=1&e=…` を新規 GET しても canonical はクリーンURLになる
       (2026-08-13 実測。第2話で確認済み)。**これは未文書化挙動なので、
       shopify-infinite-scroll/canonical運用メモ.md の月次チェックで監視する**。
     ★付与そのものを止めたいときはセクション設定「表示URLに ?n=&e= を付ける」を OFF。 */
  function displayUrl(entry) {
    var url = entry.getAttribute("data-url");
    if (!url) return null;
    if (!root || root.getAttribute("data-url-params") !== "true") return url;
    var all = entries();
    var n = all.indexOf(entry);
    if (n <= 0) return url;                       // 入口記事はクリーンURLのまま
    var first = all[0];
    var e = first && first.getAttribute("data-handle");
    if (!e || !SAFE_KEY.test(e)) return url;
    return url + (url.indexOf("?") >= 0 ? "&" : "?")
           + "n=" + n + "&e=" + encodeURIComponent(e);
  }

  function commitPrimary(entry) {
    var handle = entry.getAttribute("data-handle");
    if (!handle || handle === currentHandle) return;
    currentHandle = handle;
    var title = entry.getAttribute("data-title");
    var url = displayUrl(entry);
    /* ★title は replaceState の**前**に入れる。GA4 を履歴イベントベースで
       使うと、順序を逆にしたとき「URLは記事B / タイトルは記事A」のPVが飛ぶ。 */
    if (title) {
      try { document.title = title; } catch (error) { /* noop */ }
    }
    if (url) {
      /* replaceState にする。pushState だと戻るボタンがスクロール量ぶん
         積み上がった履歴を1つずつ遡ることになり、離脱できなくなる。
         ★canonical・robots・OG・JSON-LD は**一切触らない**(設計まとめ S7)。
           触ってよいのは document.title と表示URLだけ。 */
      try { history.replaceState(history.state, "", url); } catch (error) { /* noop */ }
    }
    syncSidebar(entry);
    ensureSidebarTrack(entry);
  }

  /* ── 前方(自動) ── */

  var appending = false;
  var appendCount = 0;

  function tailEntry() {
    var all = entries();
    return all.length ? all[all.length - 1] : null;
  }

  function headEntry() {
    var all = entries();
    return all.length ? all[0] : null;
  }

  function appendNext() {
    if (appending || !root) return;
    var tail = tailEntry();
    if (!tail) return;
    var next = tail.getAttribute("data-next") || "";
    if (!next) { say("これが最後の教材です"); stopSentinel(); return; }
    if (entries().length >= MAX_ENTRIES) {
      say("読み込みの上限に達しました。続きは各ページから読めます");
      stopSentinel();
      return;
    }
    appending = true;
    say("次の教材を読み込んでいます…");
    fetchEntry(next).then(function (node) {
      var sentinel = root.querySelector("[data-hta-sentinel]");
      sentinel.parentNode.insertBefore(prepareNode(node, false), sentinel);
      initTryIt(node);
      initCopy(node);
      observeEntry(node);
      appendCount += 1;
      say("");
    }).catch(function (error) {
      say("次の教材を読み込めませんでした: " + (error && error.message ? error.message : error));
      stopSentinel();
    }).finally(function () {
      appending = false;
    });
  }

  /* ── 後方(ボタン) ──
     自動の上方向ロードは、読んでいる位置が勝手に動くのと区別が付かず
     操作不能になりやすい。明示クリックにする。 */

  var prepending = false;

  function updateBackButton() {
    var button = root && root.querySelector("[data-hta-back]");
    if (!button) return;
    var head = headEntry();
    var prev = head && head.getAttribute("data-prev");
    button.hidden = !prev;
  }

  function prependPrev() {
    if (prepending || !root) return;
    var head = headEntry();
    if (!head) return;
    var prev = head.getAttribute("data-prev") || "";
    if (!prev) { updateBackButton(); return; }
    if (entries().length >= MAX_ENTRIES) {
      say("読み込みの上限に達しました");
      return;
    }
    prepending = true;
    var button = root.querySelector("[data-hta-back]");
    if (button) { button.disabled = true; button.textContent = "読み込んでいます…"; }

    fetchEntry(prev).then(function (node) {
      prepareNode(node, true);
      /* 高さ補正は **アンカー要素の位置差** で行う。
         document.scrollHeight の差分では合わない。挿入によって既存記事に
         `.gp-manga-article__entry + .gp-manga-article__entry` の margin/padding/border が
         付き、その増分が「アンカーより上に増えた量」と一致しないため
         (実測: scrollHeight 差 3919px に対し、実際に上へ増えたのは 3886px)。

         読んでいた記事の viewport 上の位置を直接保つこの方式なら、
         Try it バーの挿入・戻るボタンの消失・記事間マージンの発生を
         まとめて吸収できる。測定〜挿入〜補正の間に await を挟まないこと。 */
      var beforeTop = head.getBoundingClientRect().top;
      head.parentNode.insertBefore(node, head);
      initTryIt(node);
      initCopy(node);
      updateBackButton();
      var afterTop = head.getBoundingClientRect().top;
      window.scrollTo({ top: window.scrollY + (afterTop - beforeTop), behavior: "instant" });
      observeEntry(node);
      say("");
    }).catch(function (error) {
      say("前の教材を読み込めませんでした: " + (error && error.message ? error.message : error));
    }).finally(function () {
      prepending = false;
      if (button) { button.disabled = false; button.textContent = "↑ 前の教材を読み込む"; }
      updateBackButton();
    });
  }

  /* ── 監視 ── */

  var sentinelObserver = null;
  var primaryObserver = null;

  function stopSentinel() {
    if (sentinelObserver) sentinelObserver.disconnect();
    sentinelObserver = null;
  }

  function observeEntry(entry) {
    if (primaryObserver) primaryObserver.observe(entry);
  }

  function start() {
    /* Try it は無限スクロールに依存しない。[data-gp-manga-article] が無い
       描画(セクションのフォールバック枝・テスト用の素の HTML)でも動かす。 */
    initTryIt(document);
    initCopy(document);
    initSideDrawer();
    if (!root) return;

    var first = headEntry();
    if (first) {
      currentHandle = first.getAttribute("data-handle");
      syncSidebar(first);
    }

    var backButton = root.querySelector("[data-hta-back]");
    if (backButton) backButton.addEventListener("click", prependPrev);
    updateBackButton();

    if (!("IntersectionObserver" in window)) return;
    addLatchListeners();
  }

  /* ══════════════════════════════════════════════════════════
     S10: **isTrusted な実操作の latch**(2026-08-13 追加)
     ──────────────────────────────────────────────────────────
     観測を始めるのは「人が実際に操作した」あとだけにする。

     なぜ必要か(shopify-infinite-scroll/無限スクロールSEO設計まとめ より):
       Googlebot はレンダリング時にスクロール等のユーザー操作をしない。
       ラッチを置くと、クローラーが見る rendered HTML は
       **入口記事だけ + 自己参照 canonical** で一貫する。
       置かないと、レンダリング中に sentinel が可視と判定されて追記と
       replaceState が走り、「第1話のURLに第2話の本文が入った HTML」を
       クローラーへ見せうる(別URLの本文が重複して載る)。
     ★合成イベント(click() / dispatchEvent)は `isTrusted !== true` なので無視する。
       これは人間の証明ではなく「UA が作ったイベント」の印にすぎないが、
       クローラー対策としてはこれで足りる(元実装と同じ判断)。
     ══════════════════════════════════════════════════════════ */

  var latched = false;
  var LATCH_EVENTS = ["pointerdown", "touchstart", "wheel", "keydown", "click"];

  function removeLatchListeners() {
    LATCH_EVENTS.forEach(function (t) {
      window.removeEventListener(t, latch, { capture: true });
    });
  }

  function latch(event) {
    if (latched) return;
    if (!event || event.isTrusted !== true) return;
    latched = true;
    removeLatchListeners();
    startObservers();
  }

  function addLatchListeners() {
    LATCH_EVENTS.forEach(function (t) {
      window.addEventListener(t, latch, { passive: true, capture: true });
    });
  }

  function startObservers() {
    if (!root) return;
    /* 画面の上寄り 20%〜30% の帯に入った記事を「今読んでいる記事」とする。 */
    primaryObserver = new IntersectionObserver(function (records) {
      records.forEach(function (record) {
        if (record.isIntersecting) commitPrimary(record.target);
      });
    }, { rootMargin: "-20% 0px -70% 0px", threshold: 0 });
    entries().forEach(observeEntry);

    var sentinel = root.querySelector("[data-hta-sentinel]");
    if (!sentinel) return;
    sentinelObserver = new IntersectionObserver(function (records) {
      if (records.some(function (record) { return record.isIntersecting; })) appendNext();
    }, { rootMargin: "0px 0px " + PRELOAD_PX + "px 0px", threshold: 0 });
    sentinelObserver.observe(sentinel);
  }

  /* 公開 API。
     appendNext / prependPrev は通常 sentinel とボタンから呼ばれるが、
     手動でも叩けるようにしておく。IntersectionObserver は
     **非表示タブでは配信されない**(描画フレームが無いため)ので、
     ヘッドレス検証ではここから直接呼んで前後の追記を確認する。 */
  window.GpManga = {
    initTryIt: initTryIt,
    initCopy: initCopy,
    initSideDrawer: initSideDrawer,
    syncSidebar: syncSidebar,
    appendNext: appendNext,
    prependPrev: prependPrev,
    entries: entries
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
  document.addEventListener("shopify:section:load", function (event) { initTryIt(event.target); initCopy(event.target); });
})();
